import { Box, HStack } from '@chakra-ui/react'
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext'
import { AppPanelToggleButton } from '@src/components/sco/AppLayout/Panel/AppPanelToggleButton'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'

type RequestsMainPanelMobileToolbarProps = {
  showBreakpoints?: any
  children?: any
  containerProps?: any
}

export const RequestsMainPanelMobileToolbar = (props: RequestsMainPanelMobileToolbarProps) => {
  const { getBreakpointValue } = useBreakpointContext()
  const parentLayout = useParentAppLayout()

  const show = props.showBreakpoints ? getBreakpointValue(props.showBreakpoints) : true

  const asideHasContent = !!parentLayout.getPanel('requests-aside')?.children

  if (!show) {
    return <></>
  }

  return (
    <HStack padding={2} {...props.containerProps}>
      <AppPanelToggleButton panelId={'requests-nav'} panelPosition={'left'} />
      <Box flexGrow={1}>{props.children}</Box>
      {asideHasContent && <AppPanelToggleButton panelId={'requests-aside'} panelPosition={'right'} />}
    </HStack>
  )
}
